import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function Authorization() {
    const token = useSelector(state => state.auth.token);
    const location = useLocation();

    return (<>
        {(  
            token !== null  ||  
            location.pathname === "/login"  ||  
            location.pathname === "/password/forgot"  ||  
            location.pathname === "/password/reset"  ||  
            location.pathname === "/register"  ||
            location.pathname === "/Account/register.aspx"
        ) ? 
            <Outlet /> : 
            <Navigate to="/login" />}
    </>)
}